import React, {MouseEvent} from 'react';
import styled from 'styled-components'
import {Black} from '../../Constants/ColorChart'
import {JSX} from "react/jsx-runtime";
import IntrinsicAttributes = JSX.IntrinsicAttributes;

const StyledIcon = styled.svg`
  fill: ${props => props.fillColor ? props.fillColor : "none"};
  stroke: ${props => props.color ? props.color : Black};
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
  stroke-width: 1px;
  width: 20px;
  padding: 1px;
  ${props => props.iconStyle && props.iconStyle};
  &:hover {
    stroke-width: 1.5px;
  }
  @media (min-width: 1200px) {
    width: ${props => props.width ? props.width : "40px"};
  }
`;

type FeatherIconWrapperProps = {
    color?: string;
    width?: string;
    fillColor?: string;
    fillSecondaryColor?: string | null;
    iconStyle?: IntrinsicAttributes | React.CSSProperties | string;
    onClick?: (event: MouseEvent<HTMLOrSVGElement>) => void;
    Icon: React.FC<{ fillSecondaryColor?: string | null; isActive?: boolean }>;
    isActive?: boolean;
    className?: string | null;
    ariaLabel?: string | null;
    role?: string | null;
}

const FeatherIconWrapper: React.FC<FeatherIconWrapperProps> = ({
                                                                   color,
                                                                   width,
                                                                   fillColor,
                                                                   fillSecondaryColor,
                                                                   iconStyle,
                                                                   onClick,
                                                                   Icon,
                                                                   isActive,
                                                                   className,
                                                                   ariaLabel,
                                                                   role
                                                               }) => {
    return (
        <StyledIcon
            role={role ? role : ""}
            aria-label={ariaLabel ? ariaLabel : ""}
            color={color}
            width={width}
            className={className ? className : ""}
            fillColor={fillColor}
            iconStyle={iconStyle}
            onClick={onClick}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <Icon fillSecondaryColor={fillSecondaryColor} isActive={isActive}/>
        </StyledIcon>
    )
};


export default FeatherIconWrapper;
